/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import {
  absoluteFill,
  coverGlass,
  frostGlass,
  openButton,
} from "./classroomStyle";
import { titleFont } from "assets/jss/material-kit-pro-react";

const styles = (theme) => {
  const secondaryColor = theme.palette.secondary.main;
  const secondaryColorLight = theme.palette.secondary.light;

  const pipPlayer = {
    position: "relative",
    padding: 0,
    background: "inherit",
  };

  return {
    player: {
      margin: 0,
      ...absoluteFill,
    },

    playerZone: {
      gridArea: "player",
      position: "relative",
      background: "inherit",
    },

    // *** JWPLAYER *** BEGIN
    //
    playerBox: {
      ...coverGlass,
    },

    playerBoxContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      zIndex: 1,
      color: "#FFFFFF",
      "@media (min-width: 400px)": {
        padding: "0 2rem",
      },
      padding: "0 1rem",
      ...titleFont,
    },

    playerBttons: {
      display: "inline-block",
      "& > :not(:last-child)": {
        marginRight: "1rem",
      },
    },

    playerBtn: {
      marginTop: "1rem",
      borderRadius: "12px",
      textTransform: "none",
      fontWeight: 500,
    },
    //
    // *** JWPLAYER *** END

    // Note: To make the Dialog modeless, the solution is:
    // root: { pointerEvents: none }  AND  paper: { pointerEvents: auto }
    pipRoot: {
      pointerEvents: "none",
    },

    pipPaper: {
      pointerEvents: "auto",
      background: "inherit", // make PlayBox semi-transparent
    },

    pipPlayerL: {
      ...pipPlayer,
      width: "60vw",
      height: "33.75vw",
    },

    pipPlayerS: {
      ...pipPlayer,
      width: "30vw",
      height: "16.875vw",
    },

    pipTitleBar: {
      color: "white",
      backgroundColor: secondaryColor,
      cursor: "move",
      padding: "0.5rem 1rem",
    },

    pipTitleText: {
      "@media (min-width: 1025px)": {
        fontSize: "1rem",
      },
      fontSize: "0.75rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
  };
};

export default styles;
